/**
* Testimonial Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonial Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'testimonial-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.testimonial-slider' ).length ) {
        $( '.testimonial-slider' ).each( function( index, component ) {
          const splide = new Splide( $( component ).find( '.testimonial-slider__slider' )[0], {
            type: 'loop',
            gap: '2rem',
            perPage: 1,
            perMove: 1,
            pagination: false,
            speed: 800,
          } ).mount( {} );

          splide.on( 'overflow', function( isOverflow ) {
            splide.options = {
              arrows: isOverflow,
              drag: isOverflow,
            };
          } );

          const leftSplide = new Splide( $( component ).find( '.testimonial-slider__images--left' )[0], {
            type: 'loop',
            pagination: false,
            arrows: false,
            gap: '12px',
            autoWidth: true,
            autoHeight: true,
            height: '600px',
            direction: 'ttb',
            breakpoints: {
              1024: {
                direction: 'ltr',
                height: 'auto',
                autoWidth: true,
              },
            },
            autoScroll: {
              speed: 0.5,
            },
          } );

          const rightSplide = new Splide( $( component ).find( '.testimonial-slider__images--right' )[0], {
            type: 'loop',
            pagination: false,
            arrows: false,
            gap: '12px',
            autoWidth: true,
            autoHeight: true,
            height: '600px',
            direction: 'ttb',
            rtl: true,
            breakpoints: {
              1024: {
                direction: 'ltr',
                height: 'auto',
                autoWidth: true,
                rtl: true,
              },
            },
            autoScroll: {
              speed: -0.5,
            },
          } );

          leftSplide.mount( {AutoScroll} );
          rightSplide.mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonial-slider', COMPONENT );
} )( app );
